import { widget,WidgetPlugin } from '@sagold/react-json-editor';

import { FormField } from '../../../components/formfield/FormField';
import { FormLabel } from '../../../components/formlabel/FormLabel';

export const UnknownWidget = widget(({ node, options }) => (
  <FormField widgetType="string" node={node} options={options}>
    <div
      className="rje-field rje-field--unknown rje-field--error"
      data-type="unknown"
      data-id={node.pointer}
    >
      <FormLabel label={`Unknown widget for node at '${node.pointer}'`} />
      <FormField.Description>
        {JSON.stringify({ ...node }, null, 2)}
      </FormField.Description>
    </div>
  </FormField>
));

export const UnknownWidgetPlugin: WidgetPlugin = {
  id: 'unknown-widget',
  use: () => true,
  Widget: UnknownWidget,
};
